import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { fetchLoans } from 'actions/loans';
import Search from '@material-ui/icons/Search';
import Add from '@material-ui/icons/Add';
import _ from 'lodash';
import EnhancedTable from '../Table';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px',
    alignItems: 'center'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  }
});

const colNames = [
  { id: 'loanNumber', type: 'string', label: 'Settlement' },
  { id: 'createdAt', type: 'date', label: 'Settlement Date' },
  { id: 'orgName', type: 'string', label: 'Company' },
  { id: 'status', type: 'string', label: 'Status' },
  { id: 'principal', type: 'number', label: 'Principal' },
  { id: 'referralCommission', type: 'number', label: 'Commission' },
  { id: 'applicationNumber', type: 'string', label: 'Application' }
];

class Settlements extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(fetchLoans());
  };

  renderLoan = (loan) => {
    return (
      <TableRow className={this.props.classes.row} key={loan.number + Math.random().toString()}>
        <TableCell>
          <Link to={`/loans/${loan.loanNumber}`}>
            {loan.loanNumber}
          </Link>
        </TableCell>
        <TableCell>
          {moment(loan.confirmedAt).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          {loan.orgName}
        </TableCell>
        <TableCell>
          {loan.status}
        </TableCell>
        <TableCell>
          {dollars(loan.principal)}
        </TableCell>
        <TableCell>
          {dollars(loan.referralCommission)}
        </TableCell>
        <TableCell>
          { <Link to={`/applications/${loan.applicationNumber}`}><Search /></Link> }
        </TableCell>
      </TableRow>
    );
  }

  renderHeading = () => {
    return (
      <div className={this.props.classes.heading}>
        <Typography variant='headline'>
          Settlements
        </Typography>
      </div>
    );
  }

  render = () => {
    const { loans, classes } = this.props;

    if (_.isEmpty(loans)) {
      return null;
    }
    return (
      <EnhancedTable data={loans} renderHeading={this.renderHeading} renderRow={this.renderLoan} colNames={colNames}/>
    );
  };
}

const mapStateToProps = (state) => {
  let loans = state.loans && state.loans.list;
  // if (state.applications.filtered && state.applications.filtered.length > 0) {
  //   applications = state.applications.filtered;
  // }
  return { loans };
};

const styled = withStyles(styles)(Settlements)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Loans/List.js